import api from "./api";

type CallbackFunction = (args: any, headers?: any) => void;

const savePlanning = (
	data: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api[data.planning && data.planning._id ? "post" : "post"](
		"/planning" +
			(data.planning && data.planning._id ? "/" + data.planning._id : ""),
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const getPlanning = (
	params: object,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.get(
		"/planning",
		{ params },
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};
const getEmployeePlanning = (
	params: object,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.get(
		"/planning/employee",
		{ params },
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const updateDayPlanning = (
	data: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.patch(
		"/planning/updateDay",
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const login = (
	data: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.post(
		"/login",
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const getUsers = (
	params: object,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.get(
		"/users",
		{ params },
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const getOneUser = (
	id: string | number,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.get(
		"/users/" + id,
		{},
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const saveUser = (
	data: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api[data._id ? "patch" : "post"](
		"/user" + (data._id ? "/" + data._id : ""),
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const getInvoices = (
	params: object,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.get(
		"/invoices",
		{ params },
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const saveInvoice = (
	data: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.post(
		"/invoice" + (data._id ? "/" + data._id : ""),
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const getShifts = (
	params: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.get(
		"/shifts",
		{ params },
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const getOneShift = (
	id: string | number,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.get(
		"/shifts/" + id,
		{},
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const saveShift = (
	data: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api[data._id ? "patch" : "post"](
		"/shift" + (data._id ? "/" + data._id : ""),
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const getCongesRecup = (
	params: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.get(
		"/employee/vacations",
		{ params },
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};

const saveCongesRecup = (
	data: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction
) => {
	api.post(
		"/employee/vacation" + (data._id ? "/" + data._id : ""),
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		}
	);
};
const saveCongesRecupBulk = (
	data: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction,
) => {
	api.post(
		'/employee/vacations/bulk',
		data,
		(res) => successCallback(res),
		(err) => failureCallback(err),
	);
};
const deleteOneCongesRecup = (
	data: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction,
) => {
	api.del(
		'/employee/vacation/' + data.id,
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		},
	);
};

const getDocuments = (
	params: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction,
) => {
	api.get(
		'/documents',
		{ params },
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		},
	);
};

const uploadDocuments = (
	data: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction,
) => {
	return api.post(
		'/documents/upload',
		data,
		(res) => {
			return successCallback(res);
		},
		(err) => {
			return failureCallback(err);
		},
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		},
	);
};

const downloadDocument = (
	params: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction,
) => {
	return api.get(
		'/document/download',
		{ params },
		(res, headers) => {
			return successCallback(res, headers);
		},
		(err) => {
			return failureCallback(err);
		},
		{
			responseType: 'blob',
			headers: {
				Accept: 'application/octet-stream, */*',
			},
		},
	);
};

const deleteDocument = (
	params: any,
	successCallback: CallbackFunction,
	failureCallback: CallbackFunction,
) => {
	return api.get(
		'/document/delete/' + params.id,
		{},
		(res, headers) => {
			return successCallback(res, headers);
		},
		(err) => {
			return failureCallback(err);
		},
		{
			responseType: 'blob',
			headers: {
				Accept: 'application/octet-stream, */*',
			},
		},
	);
};

const services = {
	savePlanning,
	getPlanning,
	getEmployeePlanning,
	updateDayPlanning,
	login,
	getUsers,
	getOneUser,
	saveUser,
	getInvoices,
	saveInvoice,
	getShifts,
	getOneShift,
	saveShift,
	getCongesRecup,
	saveCongesRecup,
	saveCongesRecupBulk,
	deleteOneCongesRecup,
	getDocuments,
	uploadDocuments,
	downloadDocument,
	deleteDocument,
};
export default services;
